import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import NoItemResult from '../../../components/results/NoItemResult';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import useGoTo from '../../../utilities/useGoTo';
import PromoCodeList from './PromoCodeList';

const PromoCodeListPage = () => {
    const { t } = useTranslation(['promoCodeDetails', 'promoCodeList']);
    const company = useCompany(true);
    const { permissions: accountPermissions } = useAccount();

    const goToNewPromoCodePage = useGoTo('/admin/promoCodes/add');

    const extra =
        company &&
        company.availableModules.hasPromotionCodeModules &&
        hasPermissions(accountPermissions, [permissionKind.createPromoCode]) ? (
            <Button icon={<PlusOutlined />} onClick={goToNewPromoCodePage} type="primary">
                {t('promoCodeList:actions.newPromoCode')}
            </Button>
        ) : null;

    return (
        <ConsolePageWithHeader extra={extra} title={t('promoCodeList:title')}>
            {!company || company.availableModules.hasPromotionCodeModules ? (
                <PromoCodeList />
            ) : (
                <NoItemResult subTitle={t('promoCodeDetails:moduleNotAvailable')} />
            )}
        </ConsolePageWithHeader>
    );
};

export default PromoCodeListPage;
